import { render, staticRenderFns } from "./PolicyQuery.vue?vue&type=template&id=5a19cdb4&scoped=true"
import script from "./PolicyQuery.vue?vue&type=script&lang=js"
export * from "./PolicyQuery.vue?vue&type=script&lang=js"
import style0 from "../fta.css?vue&type=style&index=0&id=5a19cdb4&prod&scoped=true&lang=css&external"
import style1 from "./PolicyQuery.less?vue&type=style&index=1&id=5a19cdb4&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a19cdb4",
  null
  
)

export default component.exports